import { createRouter, createWebHistory } from 'vue-router'
import { installChunkReloadGuard } from '@kyn/vue-components'

// Trang login + workspace dùng SSO đa tài khoản (identity.js). Mỗi trang tự bootstrap phiên
// trong onMounted (gọi api.accounts()/context()), nên router KHÔNG cần guard auth ở đây.
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/pages/RegisterPage.vue')
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/pages/ForgotPasswordPage.vue')
  },
  {
    // Người dùng bấm link trong mail quên mật khẩu → vào đây nhập mật khẩu mới (kèm ?token=..).
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/pages/ResetPasswordPage.vue')
  },
  {
    // Link trong thư mời / quên mật khẩu của kyn-id → đặt mật khẩu (?token=..).
    path: '/set-password',
    name: 'set-password',
    component: () => import('@/pages/SetPasswordPage.vue')
  },
  {
    // Đổi mật khẩu bắt buộc: kyn-id chuyển tới đây sau login khi tài khoản bị đặt cờ phải đổi (?token=..).
    path: '/change-password',
    name: 'change-password',
    component: () => import('@/pages/ChangePasswordPage.vue')
  },
  {
    path: '/',
    name: 'workspace',
    component: () => import('@/pages/WorkspacePage.vue')
  },
  {
    path: '/ai',
    name: 'ai-assistant',
    component: () => import('@/pages/AiAssistantPage.vue')
  },
  // tương thích ngược: link/redirect cũ tới /launcher
  { path: '/launcher', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Deploy ghi đè assets/ nên tab mở từ TRƯỚC đó giữ bundle cũ: bấm vào route lazy là nhận chunk 404
// rồi trắng màn. Guard tải lại trang một lần để lấy bundle mới, tự dừng nếu tải lại vẫn lỗi.
// App này chạy webpack (Vue CLI) nên sự kiện 'vite:preloadError' không bao giờ bắn — chỉ nhánh
// router.onError khớp mẫu ChunkLoadError của webpack là có tác dụng.
installChunkReloadGuard({ router })

export default router
